import React, { useState, useCallback } from "react";
import { FormCheckbox } from "../../components/ui";
import { trackComment, stopTrackingComment } from "api";
import {
  PostDetailBellIcon,
  PostDetailBellOffIcon,
} from "../PostDetail/PostDetailCommentIcons";

/**
 * Lovable NotifyControl:
 * - inline (≥640px): plain text + ml-auto on the action row
 * - chip (<640px): full-width pill under the action row
 * Both share one tracking state.
 */
const CommentNotification = ({
  commentId,
  comment,
  currentUser,
  variant = "legacy",
}) => {
  const commentCreatorId = comment && comment.user && comment.user.id;
  const currentUserId = currentUser && currentUser.id;
  const [waitingNotification, setWaitingNotification] = useState(
    comment && comment.tracking
  );
  const [loading, setLoading] = useState(false);

  const handleCommentTracking = useCallback(async () => {
    if (!waitingNotification) {
      setLoading(true);

      try {
        await trackComment(commentId);
        setWaitingNotification(true);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }

    if (waitingNotification) {
      setLoading(true);
      try {
        await stopTrackingComment(commentId);
        setWaitingNotification(false);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  }, [waitingNotification, commentId]);

  if (commentCreatorId === currentUserId) {
    return null;
  }

  if (variant === "postDetail") {
    const activeClass = waitingNotification ? " comment-notify-btn--active" : "";
    const chipLabel = waitingNotification
      ? "Notifying on analyst replies"
      : "Notify on analyst replies";
    const icon = waitingNotification ? (
      <PostDetailBellIcon />
    ) : (
      <PostDetailBellOffIcon />
    );

    /* Lovable: inline on action row (≥640); chip in its own row below (<640) */
    return (
      <>
        <button
          type="button"
          className={`comment-notify-btn comment-notify-btn--inline${activeClass}`}
          disabled={loading}
          onClick={handleCommentTracking}
        >
          {icon}
          <span className="comment-notify">
            Notify me when an analyst replies
          </span>
        </button>
        <div className="comment-notify-chip-wrap">
          <button
            type="button"
            className={`comment-notify-btn comment-notify-btn--chip${activeClass}`}
            disabled={loading}
            onClick={handleCommentTracking}
          >
            {icon}
            <span className="comment-notify">{chipLabel}</span>
          </button>
        </div>
      </>
    );
  }

  return (
    <FormCheckbox
      className="comment-notify-toggle"
      disabled={loading}
      toggle
      small
      checked={waitingNotification}
      onChange={handleCommentTracking}
    >
      <span className="comment-notify">
        Notify me when an analyst replies
      </span>
    </FormCheckbox>
  );
};

export default CommentNotification;
